import React, { useState as _useState } from 'react'
import { useEffect as _useEffect } from 'react'
import { UserOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/hooks'
import { setShowAuthorId } from '@/features/SetShowAuthorId/setShowAuthorId'
import { SRC_URL } from '@/server'
import './index.less'

export function AuthorCard(props) {
  const { name, avatar, count, id } = props
  const dispatch = useAppDispatch()
  const _navigate = useNavigate()
  function handleClick() {
    dispatch(setShowAuthorId(id))
    // navigate("/author")
    window.open('/author')
  }
  return (
    <div className='author-card'>
      <div className='author-avatar' onClick={() => handleClick()}>
        {!avatar ? (
          <UserOutlined
            style={{
              color: '#666666',
              fontSize: '120px',
              margin: '50% auto',
              transform: 'translateY(-55%)'
            }}
          />
        ) : (
          <img src={`${SRC_URL}${avatar}`} alt={name} />
        )}
      </div>
      <div className='author-name'>{name}</div>
      <div className='author-count'>{count ?? 0} 件作品</div>
    </div>
  )
}
